var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.hideSupplier
        ? _c("autocomplete-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: `required`,
                expression: "`required`",
              },
            ],
            attrs: {
              path: "/suppliers",
              name: "supplier",
              label: "name",
              loadOnFocus: "",
              outValKey: true,
              isObject: true,
              optionsV:
                _vm.fobPoint.supplier && _vm.fobPoint.supplier.length
                  ? _vm.fobPoint.supplier
                  : [],
              "track-by": "psCode",
            },
            model: {
              value: _vm.fobPoint.supplierCode,
              callback: function ($$v) {
                _vm.$set(_vm.fobPoint, "supplierCode", $$v)
              },
              expression: "fobPoint.supplierCode",
            },
          })
        : _vm._e(),
      _c("validated-input", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: `required`,
            expression: "`required`",
          },
        ],
        attrs: { validate: "required", label: "Fob Id" },
        model: {
          value: _vm.fobPoint.fobId,
          callback: function ($$v) {
            _vm.$set(_vm.fobPoint, "fobId", $$v)
          },
          expression: "fobPoint.fobId",
        },
      }),
      _c("address-fields", {
        attrs: {
          "is-city-required": _vm.shippingRequired,
          "is-state-required": _vm.isStateRequired,
          "is-country-required": _vm.shippingRequired,
          "is-zip-required": _vm.shippingRequired,
          hide: ["street2"],
        },
        model: {
          value: _vm.fobPoint,
          callback: function ($$v) {
            _vm.fobPoint = $$v
          },
          expression: "fobPoint",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }